// @flow

// Effect Managers
import { call, fork } from 'redux-saga/effects'

// Controller
import controller from 'hfty-ctrl-orders'

// Sagas
import watchOrderOperations from './operations'
import { watchOperations } from 'hfty-operator-orders'

// Selectors
import operations$ from '../selectors/operations'

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchOrderOperations)
  yield fork(watchOperations, { operations$ })
}

